import script from "./Toaster.vue?vue&type=script&setup=true&lang=js"
export * from "./Toaster.vue?vue&type=script&setup=true&lang=js"

import "./Toaster.vue?vue&type=style&index=0&id=6350fb80&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6350fb80"]])

export default __exports__